import React, { Component } from 'react';
import Footer from '../footer/newfooter';
import Header from '../header/newheader'
import {Link} from 'react-router-dom'
import Loader from 'react-loader'
import cachios from 'cachios';
import { BASE } from "../api/api";
import ReactHtmlParser from 'react-html-parser';
import { getName } from 'country-list'

class academyOpen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nid: props.match.params.nid,
            loader: true,
            bioimg: '',
            loginred: '/login?redir=' + props.location.pathname
        }
    }

    checklogin() {
        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
            window.location.href = this.state.loginred
        }
        else
            return true

    }

    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        window.location.href = this.state.loginred
    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()

        }
    }


    componentWillMount() {
        if (this.checklogin()) {
            this.checkexpiry()
            cachios.get(BASE + 'jsonapi/node/programs?include=field_image&filter[drupal_internal__nid]=' + this.state.nid, {
                ttl: 500 /* seconds */,
            })
                .then((data) => {
                    this.topFunction()
                    if (data.data.data[0].relationships.field_image.data !== null) {
                        this.setState({
                            bioimg: BASE + data.data.included[0].attributes.uri.url
                        })
                    }
                    console.log("3344", data)
                    this.setState({
                        sub_data: data.data.data[0].attributes,
                        loader: false
                    })
                })
        }
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }


    render() {
        return (


            <div>
                <div className='institutions acaopen eventpage sub_work'>
                    <Header />
                    <div className='top-contents container'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/academic_institution/page/0'>Academic Institutions</Link> / {this.state.nid}</div>
                        </div>
                    {this.state.loader ? <Loader color="#165e84" loaded={false} className="spinner" /> : ''}
                    <div className="pub_container container">
                        <body className="wiki" >
                            <div className="main-content">
                                <div>
                                    <div className="row">
                                        <div className="node-wiki node">
                                            <div className="group-middle">
                                                <div className="field-name-title">
                                                    <div className='heading'>{this.state.sub_data ? this.state.sub_data.title : ''}</div>
                                                    <div className="acaopendiv">
                                                        {this.state.bioimg ? <div className="field-name-field-thumbnail">
                                                            <img src={this.state.bioimg} alt="CIS" />
                                                        </div> : ''}
                                                        <div className="field-name-metadata-books">
                                                            <div className="field-item even">
                                                                <div className="view-wiki">
                                                                    <ul>
                                                                        {this.state.sub_data ? this.state.sub_data.field_universitys_colleges ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">University</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_universitys_colleges}</div>
                                                                        </li> : '' : ''}
                                                                        {this.state.sub_data ? this.state.sub_data.field_contact ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Contact</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_contact}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_email ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Email</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_email[0]}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_country ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Country</div>
                                                                            <div className="field-name-field-body">{getName(this.state.sub_data.field_country)}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_fax ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">FAX</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_fax}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_location ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Location</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_location}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_phone ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Phone</div>
                                                                            <div className="field-name-field-body">{this.state.sub_data.field_phone}</div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.field_website ? <li className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <div className="field-name-field-title">Website</div>
                                                                            <div className="field-name-field-body"><a target="_blank" href={this.state.sub_data.field_website.uri}>{this.state.sub_data.field_website.uri}</a></div>
                                                                        </li> : '' : ''}

                                                                        {this.state.sub_data ? this.state.sub_data.body ? <h6>
                                                                            Profile
                                                                    </h6> : '' : ''}

                                                                        <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                                                                            <div className="field-items">
                                                                                <div className="field-item even academy-open-link" property="content:encoded">
                                                                                    {this.state.sub_data ? ReactHtmlParser(this.state.sub_data.body ? this.state.sub_data.body.processed : '') : ''}
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </body>
                    </div>
                </div>
                <div><Footer /></div>
            </div>
        );
    }
}

export default academyOpen;